import { useContext } from 'react';
import { AddChannelDialogContext } from './context';

export function useAddChannelDialog() {
  const context = useContext(AddChannelDialogContext);
  if (!context) {
    throw new Error(
      'useAddChannelDialog must be used within AddChannelDialogProvider'
    );
  }
  return context;
}
